module.exports = __webpack_public_path__ + "static/media/gifts and accesories.c5206cd9.JPG";